import { createCallsClient } from '@wtfalch/calls';
import type { CallEndpointAdapter } from '@wtfalch/calls/browser';
import { createLiveKitAdapter } from '@wtfalch/calls/livekit';

import { memoryStore } from './memoryStore.ts';
import type { RoomCallBinding } from './roomCalls.ts';

/**
 * The calls binding for one signed-in agora: the control client and the media
 * adapter. Member requests carry the agora's access token as a bearer (read
 * again on every request, so a rotation is picked up) and `deviceId` as
 * `x-calls-device`; no cookie.
 *
 * `baseUrl` is the `/_calls` mount point. The engine sends its own Matrix
 * gateway calls under it too, so they never reach Agora's `/_matrix` route.
 */
export function createCallsBinding({
  baseUrl,
  getAccessToken,
  deviceId,
  createAdapter = defaultAdapter,
}: {
  baseUrl: string;
  getAccessToken: () => string;
  deviceId: string;
  createAdapter?: () => CallEndpointAdapter;
}): RoomCallBinding {
  const options = { baseUrl, token: getAccessToken, deviceId };
  return {
    client: createCallsClient(options),
    // The engine is created by `useCallEndpoint`; it takes the same options.
    endpointOptions: options,
    adapter: createAdapter(),
    store: memoryStore(),
  };
}

function defaultAdapter(): CallEndpointAdapter {
  return createLiveKitAdapter({});
}
